import { putPromise } from "./request-promise";

export function updateDesignBurdens(designBurdenParams) {
	return putPromise(
		'api/dashboards/highchart_analytics/add_design_burden',
		designBurdenParams,
		(data) => data || null
	);
}